'use client';
import { ChevronDown } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '../../utils';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui';

export enum DropdownMenuContentKeywords {
  Separator = 'separator-dropdown-menu-keyword',
  Add = 'add-new-team-dropdown-menu-keyword',
}

export function DropdownMenuSelect(props: {
  onSelect: (val: string) => void;
  val: string | null;
  values:
    | string[]
    | (
        | { label: ReactNode; value: string | number; displayLabel?: string }
        | {
            value: DropdownMenuContentKeywords.Separator;
          }
        | {
            value: DropdownMenuContentKeywords.Add;
            onAdd: () => void;
            displayLabel: string;
          }
      )[];
  defaultLabel?: string;
  dropdownMenuClassName?: string;
  className?: string;
}) {
  // TODO reformat values to be an array of objects always
  const formattedValues = props.values.map((value) => {
    if (typeof value === 'string') {
      return {
        label: value,
        value: value,
        displayLabel: value,
      };
    }

    if (value.value === DropdownMenuContentKeywords.Separator) {
      return {
        label: 'Separator',
        value: value.value,
        displayLabel: 'Separator',
      };
    }
    if (value.value === DropdownMenuContentKeywords.Add && 'onAdd' in value) {
      return {
        label: value.displayLabel,
        value: value.value,
        displayLabel: value.displayLabel,
        onAdd: value.onAdd,
      };
    }

    // fix the anys
    return {
      label: (value as any).label,
      value: value.value,
      displayLabel: (value as any).displayLabel ?? (value as any).label,
    };
  });

  const selectedValue = props.val
    ? formattedValues.find((value) => value.value === props.val)
    : null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant={'outline'}
          className={cn(
            'flex w-full items-center justify-between',
            props.className
          )}
        >
          {selectedValue ? selectedValue.displayLabel : props.defaultLabel}
          <ChevronDown size={15} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className={cn('z-50', props.dropdownMenuClassName)}>
        <DropdownMenuRadioGroup
          value={props.val ?? undefined}
          onValueChange={(newValue) => {
            if (newValue !== DropdownMenuContentKeywords.Add) {
              props.onSelect(newValue);
            }
          }}
        >
          {formattedValues.map((value) => {
            if (value.value === DropdownMenuContentKeywords.Separator) {
              return <DropdownMenuSeparator key={value.value.toString()} />;
            }
            if (
              value.value === DropdownMenuContentKeywords.Add &&
              'onAdd' in value
            ) {
              console.log('value', value);
              return (
                <DropdownMenuRadioItem
                  key={value.value.toString()}
                  value={DropdownMenuContentKeywords.Add}
                  onClick={(e) => {
                    e.preventDefault();
                    value.onAdd?.();
                  }}
                >
                  {value.label}
                </DropdownMenuRadioItem>
              );
            }
            return (
              <DropdownMenuRadioItem
                key={value.value.toString()}
                value={value.value.toString()}
              >
                {value.label}
              </DropdownMenuRadioItem>
            );
          })}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
